/**
 * Hàm loại bỏ các field là function trong object để tránh lỗi khi lưu vào state/storage
 * @param {any} obj 
 * @returns 
 */
function removeFunctions(obj) {
	if (typeof obj !== 'object' || obj === null) return obj;
	if (Array.isArray(obj)) return obj.map(removeFunctions);

	const newObj = {};
	for (const key in obj) {
		if (typeof obj[key] !== 'function') {
			newObj[key] = removeFunctions(obj[key]);
		}
	}
	return newObj;
}

/**
 * state mặc định của module
 */
export default {
	updateNotificationUser(state, res) {
		state.NotificationUser = res;
	},

	updateIsShowNotification(state, res) {
		state.IsShowNotification = res;
	},

	updateNotificationInvoiceWaiting(state, res) {
		state.NotificationInvoiceWaiting = res;
	},

	updateNotificationsInbot(state, res) {
		state.NotificationsInbot = res;
	},

	updateNotificationProcessSyncData(state, res) {
		state.NotificationProcessSyncData = [...res];
	},

	updateNotificationProcessSyncDataByIndex(state, res) {
		if (!res) return;
		state.NotificationProcessSyncData[res.index] = res.data;
		state.NotificationProcessSyncData[res.index].Percentage = res.data.Percentage;
	},

	addNotificationProcessSyncData(state, res) {
		if (!state.NotificationProcessSyncData) {
			state.NotificationProcessSyncData = [];
		}
		state.NotificationProcessSyncData.push(res);
		state.NotificationProcessSyncData[state.NotificationProcessSyncData.length - 1].Percentage = res.Percentage;
	},

	remoteNotificationSyncData(state, syncId) {
		if (!syncId) return;
		state.NotificationProcessSyncData = state.NotificationProcessSyncData.filter(x => x.SyncTimeId != syncId);
	},

	remoteNotificationSyncDataById(state, id) {
		if (!id) return;
		state.NotificationProcessSyncData = state.NotificationProcessSyncData.filter(x => x.id != id);
	},

	updateNotificationChangeStatusInvoice(state, res) {
		state.IsShowNotificationChangeStatusInvoice = res;
	},

	updateIsShowNewFeature(state, res) {
		state.IsShowNewFeature = res;
	},

	updateAssistantPanelData(state, res) {
		state.AssistantPanelData = res;
	},

	/**
	 * Cập nhật dữ liệu cho Assistant Panel theo OrgId
	 * Dữ liệu đầu vào cần có cấu trúc { horizontalReminders: [], assistantReminders: [] } (hoặc một phần)
	 */
	updateAssistantPanelDataByOrg(state, { orgId, data }) {
		if (!state.AssistantPanelData) {
			state.AssistantPanelData = [];
		}

		// Lọc bỏ function trước khi lưu
		const sanitizedData = removeFunctions(data);
		const orgKey = String(orgId);

		const index = state.AssistantPanelData.findIndex(x => x.orgId == orgKey);
		const newItem = {
			orgId: orgKey,
			// Default empty arrays if not provided
			horizontalReminders: [],
			assistantReminders: []
		};
		// Object.assign instead of spread ... to avoid parsing error
		Object.assign(newItem, sanitizedData);

		if (index > -1) {
			// Merge logic
			const currentItem = state.AssistantPanelData[index];
			const mergedItem = Object.assign({}, currentItem, sanitizedData);
			state.AssistantPanelData[index] = mergedItem;
		} else {
			// New item
			state.AssistantPanelData.push(newItem);
		}
	},

	/**
		* Xử lý Push Notification cho Invoice Waiting (Vị trí 1 - Horizontal)
		* Cập nhật lại danh sách horizontalReminders cho Org tương ứng
		*/
	handlePushNotificationInvoiceWaiting(state, { orgId, data }) {
		if (!orgId) return;

		// Lọc bỏ function trước khi lưu
		const sanitizedData = removeFunctions(data);
		const orgKey = String(orgId);

		if (!state.AssistantPanelData) state.AssistantPanelData = [];

		const index = state.AssistantPanelData.findIndex(x => x.orgId == orgKey);
		if (index > -1) {
			const currentItem = state.AssistantPanelData[index];
			const newItem = Object.assign({}, currentItem, { horizontalReminders: sanitizedData });
			state.AssistantPanelData[index] = newItem;
		} else {
			state.AssistantPanelData.push({
				orgId: orgKey,
				horizontalReminders: sanitizedData,
				assistantReminders: []
			});
		}
	},

	/**
		* Cập nhật horizontalReminders cho một orgId cụ thể
		* (Giữ lại để tương thích nếu cần, đã được bao hàm trong updateAssistantPanelDataByOrg)
		*/
	updateHorizontalReminders(state, { orgId, horizontalReminders }) {
		if (!state.AssistantPanelData) {
			state.AssistantPanelData = [];
		}

		const sanitizedData = removeFunctions(horizontalReminders);
		const orgKey = String(orgId);

		const index = state.AssistantPanelData.findIndex(x => x.orgId == orgKey);
		if (index > -1) {
			const currentItem = state.AssistantPanelData[index];
			const newItem = Object.assign({}, currentItem, { horizontalReminders: sanitizedData });
			state.AssistantPanelData[index] = newItem;
		} else {
			state.AssistantPanelData.push({
				orgId: orgKey,
				horizontalReminders: sanitizedData,
				assistantReminders: []
			});
		}
	},

	/**
		* Cập nhật assistantReminders cho một orgId cụ thể
		*/
	updateAssistantReminders(state, { orgId, assistantReminders }) {
		if (!state.AssistantPanelData) {
			state.AssistantPanelData = [];
		}

		const sanitizedData = removeFunctions(assistantReminders);
		const orgKey = String(orgId);

		const index = state.AssistantPanelData.findIndex(x => x.orgId == orgKey);
		if (index > -1) {
			const currentItem = state.AssistantPanelData[index];
			const newItem = Object.assign({}, currentItem, { assistantReminders: sanitizedData });
			state.AssistantPanelData[index] = newItem;
		} else {
			state.AssistantPanelData.push({
				orgId: orgKey,
				horizontalReminders: [],
				assistantReminders: sanitizedData
			});
		}
	},

	/**
	 * Xóa dữ liệu của các orgId khác, chỉ giữ lại dữ liệu của orgIdWorking hiện tại
	 * Mục đích: Giảm dung lượng cache, chỉ lưu dữ liệu của org đang làm việc
	 */
	clearOtherOrgData(state, orgIdWorking) {
		if (!orgIdWorking || !state.AssistantPanelData) {
			return;
		}
		const orgKey = String(orgIdWorking);
		// Chỉ giữ lại dữ liệu của orgIdWorking
		state.AssistantPanelData = state.AssistantPanelData.filter(x => x.orgId == orgKey);
	}
};
